import React from "react";
import Reveal from "./Reveal";

const INDUSTRIES = [
  { name: "Education", line: "HIT inaugural edition — 700+ students trained, 70 pods, 1,000+ at Grand Finale." },
  { name: "Healthcare", line: "AI+ Doctor Practitioner™, AI+ Nurse™, AI+ Pharma™ — clinical workflow automation." },
  { name: "Finance & Accounting", line: "ICMAI partnership — AI for Finance Builder + Leader tracks." },
  { name: "Legal", line: "AI+ Lawyer Practitioner™ — drafting, research, due diligence." },
  { name: "Sales & Marketing", line: "AI for Sales, Marketing, Performance — function-specific builders." },
  { name: "Human Resources", line: "AI for HR — recruitment automation, L&D personalization." },
  { name: "Engineering & Tech", line: "AI Vibe Coder, AI+ Developer™ — ship web apps with AI." },
  { name: "Leadership", line: "Chief AI Officer Practitioner™ — board-ready AI strategy." },
];

export default function Industries() {
  return (
    <section
      id="industries"
      className="py-10 md:py-14 border-t hairline"
      data-testid="industries-section"
    >
      <div className="container-edge">
        <Reveal>
          <p className="section-number">04 — INDUSTRIES</p>
        </Reveal>
        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <Reveal>
              <h2
                className="font-display text-[40px] sm:text-[52px] lg:text-[68px] leading-[0.95] tracking-tight"
                style={{ fontWeight: 500 }}
              >
                AI capability, built for <em className="italic grad-brand-text" style={{ fontWeight: 500 }}>your industry.</em>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <Reveal delay={120}>
              <p
                className="text-[16px] md:text-[18px] leading-relaxed"
                style={{ color: "var(--ink-secondary)" }}
              >
                Every industry has its own AI maturity curve. We meet you where you are — with
                certifications, deployments, and Innovation Arena editions designed for your sector.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--border-soft)] border hairline">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.name} delay={Math.min(i, 5) * 60}>
              <article
                className="p-7 bg-canvas hover:bg-white transition-colors h-full flex flex-col"
                data-testid={`industry-${ind.name.toLowerCase().replace(/\s|&/g, "-")}`}
              >
                <p className="mono-label-gold">{String(i + 1).padStart(2, "0")}</p>
                <h3
                  className="mt-3 font-display text-[24px] tracking-tight leading-tight"
                  style={{ fontWeight: 500 }}
                >
                  {ind.name}
                </h3>
                <p
                  className="mt-3 text-[13.5px] leading-relaxed flex-1"
                  style={{ color: "var(--ink-secondary)" }}
                >
                  {ind.line}
                </p>
                <a
                  href="#enquiry"
                  className="mt-5 text-[13px] link-underline text-ink"
                  data-testid={`industry-cta-${i + 1}`}
                >
                  Explore →
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
